export function evaluateOperator (currentValue) {
  return ({ operator, value }) => {
    if (operator === 'regex') {
      return new RegExp(value, 'i').test(currentValue)
    }
    if (operator === '>') {
      return currentValue > value
    }
    if (operator === '>=') {
      return currentValue >= value
    }
    if (operator === '<') {
      return currentValue < value
    }
    if (operator === '<=') {
      return currentValue <= value
    }
    if (operator === '!=') {
      return currentValue != value
    }
    if (operator === '!==') {
      return currentValue !== value
    }
    if (operator === '==') {
      return currentValue == value
    }
    if (operator === '===') {
      return currentValue === value
    }
    return false // invalid operator
  }
}
